// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"136":"6427f1b1","275":"db76ac66","300":"a762bd8b","525":"f8bc721d","967":"db76ac66"}[chunkId] + ".chunk.css";
};